import { useContext, useMemo } from "react";
import { useStyles } from "../../RCACompliance/RCACompliance.styles";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ComplianceBar from "pages/Corporate/RCA/RCAAPCompliance/components/ComplianceBar";
import { ComplianceBarReferences } from "pages/Corporate/RCA/RCAAPCompliance/components/ComplianceBar/ComplianceBarReferences.view";
import { RCACorporateDashboardContext } from "contexts/RCACorporateDashboardContext/RCACorporateDashboardContext";
import moment from "moment";
import { RCACorporateDashboardEntity } from "entities/RCA/RCACorporateDashboardEntity/RCACorporateDashboardEntity";

const APComplianceCorporate = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { filters, handleSetComplianceType } = useContext(RCACorporateDashboardContext);
    const argsFilters = useMemo(
        () => ({
            date: moment().subtract(Number(filters.periodOption), "day").startOf("day").toISOString(),
            divisionIds: filters.divisionIds,
            totalDivisions: filters.totalDivisions,
            regionIds: filters.regionIds,
            totalRegions: filters.totalRegions,
        }),
        [filters],
    );
    const { actionPlanComplianceByMill } = RCACorporateDashboardEntity.GetActionPlanComplianceByMill(argsFilters);

    const barData = useMemo(() => {
        if (actionPlanComplianceByMill.length === 0) return [];
        const totals = actionPlanComplianceByMill.reduce(
            (acc, row) => ({
                completedOnTimeAmount: acc.completedOnTimeAmount + row.completed_on_time,
                pendingAmount: acc.pendingAmount + row.pending,
                completedLateAmount: acc.completedLateAmount + row.completed_late,
                pendingLateAmount: acc.pendingLateAmount + row.pending_late,
                total: acc.total + row.total_action_plans_by_period,
            }),
            { completedOnTimeAmount: 0, pendingAmount: 0, completedLateAmount: 0, pendingLateAmount: 0, total: 0 },
        );
        return [totals];
    }, [actionPlanComplianceByMill]);

    return (
        <div className={classes.card}>
            <div className={classes.cardHeader}>
                <Typography variant="rcaTitle" className={classes.cardTitle}>
                    {t("rca.corporate_dashboard.ap_compliance.corporate.title")}
                </Typography>
            </div>
            <div className={classes.cardBody}>
                <ComplianceBar data={barData} onComplianceTypeSelected={handleSetComplianceType} />
                {barData.length > 0 && <ComplianceBarReferences />}
            </div>
        </div>
    );
};

export default APComplianceCorporate;
